import { Button } from "@mui/material";

import Svg from "../../../../../ui library/components/svgs/standard/svg";

const ActionIconButton = ({
  label,
  iconName,
  iconColor,
  iconSx,
  onClick,
  disabled,
  sx,
  className,
}) => (
  <Button
    sx={sx}
    className={className}
    variant="contained"
    disableElevation
    onClick={onClick}
    disabled={disabled}
  >
    <span className="flex-1 text-center">{label}</span>
    <Svg name={iconName} color={iconColor} sx={iconSx ?? { width: "22px" }} />
  </Button>
);

export default ActionIconButton;
